import { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import api from '../../services/api';
import toast from 'react-hot-toast';

export default function VerifyEmailBanner() {
  const { user } = useAuth();
  const [resending,  setResending]  = useState(false);
  const [dismissed,  setDismissed]  = useState(false);

  if (!user || user.is_verified || dismissed) return null;

  const resend = async () => {
    setResending(true);
    try {
      await api.post('/auth/resend-verification');
      toast.success('Verification email sent — check your inbox');
      setDismissed(true);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to resend');
    }
    setResending(false);
  };

  return (
    <div style={{ background: '#FFFBEB', border: '1px solid #FDE68A', borderRadius: 10, padding: '10px 16px', marginBottom: 20, display: 'flex', alignItems: 'center', gap: 12, fontSize: 13 }}>
      <i className="ti ti-mail" style={{ color: '#854F0B', fontSize: 18, flexShrink: 0 }} />
      <span style={{ flex: 1, color: '#78350F' }}>
        Please verify your email address to unlock all features.
      </span>
      <button onClick={resend} disabled={resending} style={{ padding: '5px 14px', background: '#854F0B', color: '#fff', border: 'none', borderRadius: 7, fontSize: 12, fontWeight: 600, cursor: 'pointer', flexShrink: 0 }}>
        {resending ? 'Sending…' : 'Resend email'}
      </button>
      <button onClick={() => setDismissed(true)} style={{ background: 'none', border: 'none', color: '#854F0B', cursor: 'pointer', padding: '2px 4px', flexShrink: 0 }}>
        <i className="ti ti-x" style={{ fontSize: 14 }} />
      </button>
    </div>
  );
}
